var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block-text"},[_c('h1',{staticClass:"color--blue mb-3"},[_vm._t("title")],2),_vm._t("summary")],2)}
var staticRenderFns = []

export { render, staticRenderFns }